import store from "../../store";
import { canAccessDrawings } from "./access.mjs";

const Files = () => import("./Files.vue");

const ifInternalUser = (to, from, next) => {
    // Cliente/Fornitore prevale anca se l'account ga altri gruppi interni.
    if (!store.getters.isLoggedIn) return next("/login");
    if (!canAccessDrawings(store.getters.userdata)) return next("/");
    return next();
};


export default [
    {
        path: "/disegni/",
        name: "disegni",
        meta: { menu: "files", title: "Files · Disegni" },
        component: Files,
        beforeEnter: ifInternalUser,
    },
    {
        path: "/dxfcut/",
        name: "dxfcut",
        meta: { menu: "files", title: "Files · DXFCUT" },
        component: Files,
        beforeEnter: ifInternalUser,
    },
];
